import { render, staticRenderFns } from "./CollectionExplorer.vue?vue&type=template&id=3215cd82"
import script from "./CollectionExplorer.vue?vue&type=script&lang=ts"
export * from "./CollectionExplorer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports